import { LoadingButton } from "@mui/lab";
import {
  Button,
  DialogActions,
  DialogContent,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import { useSnackbar } from "notistack";
import React, { useState } from "react";
import { useUpdateExperienceMutation } from "../../services/profileAPI";
import { CustomDialogTitle } from "../../ui";

const items = [
  {
    id: "a",
    label: "0 - 3 years",
  },
  {
    id: "b",
    label: "3 - 6 years",
  },
  {
    id: "c",
    label: "6 - 9 years",
  },
  {
    id: "d",
    label: "9 - 12 years",
  },
  {
    id: "e",
    label: "12 - 15 years",
  },
  {
    id: "f",
    label: "15 - 18 years",
  },
  {
    id: "g",
    label: "18 years and above",
  },
];

function EditExperienceDialog({ yearsOfExperience, onClose }: any) {
  const [value, setValue] = useState<string>(
    items.find((item) => item.label === yearsOfExperience)!["label"]
  );

  const [updateExperience, { isLoading: isUpdateExperienceLoading }] =
    useUpdateExperienceMutation();

  const { enqueueSnackbar } = useSnackbar();

  const updateExperienceHandler = async () => {
    try {
      await updateExperience(value!).unwrap();
      enqueueSnackbar("updated your experience", {
        variant: "success",
      });
      onClose();
    } catch (error) {
      console.error(error);
      enqueueSnackbar("failed to update your experience", {
        variant: "error",
      });
    }
  };

  return (
    <>
      <CustomDialogTitle onClose={onClose}>
        <Typography>edit experience</Typography>
      </CustomDialogTitle>
      <DialogContent dividers>
        <Select
          labelId="select-experience"
          id="select-experience"
          value={value!}
          fullWidth
          onChange={(event: any) => {
            setValue(event.target.value);
          }}
          sx={{ my: 1 }}
        >
          {items.map((item) => {
            return (
              <MenuItem key={item.id} value={item.label}>
                {item.label}
              </MenuItem>
            );
          })}
        </Select>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">
          cancel
        </Button>
        <LoadingButton
          variant="text"
          type="submit"
          loading={isUpdateExperienceLoading}
          onClick={updateExperienceHandler}
        >
          update
        </LoadingButton>
      </DialogActions>
    </>
  );
}

export default EditExperienceDialog;
